var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-msg-card" }, [
    _c("div", { staticClass: "omc-head" }, [
      _c("span", { staticClass: "omc-status" }, [
        _vm._v(_vm._s(_vm.order.status))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "omc-code" }, [
        _vm._v("编码：" + _vm._s(_vm.order.id))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "omc-body" }, [
      _c("img", {
        staticClass: "omc-img",
        attrs: { src: _vm.order.imgurl, alt: "商品图" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "omc-info" }, [
        _c(
          "div",
          { staticClass: "omc-title", attrs: { title: _vm.order.productName } },
          [_vm._v(_vm._s(_vm.order.productName))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "omc-price" }, [
          _vm._v("\n\t\t\t\t¥ " + _vm._s(_vm.priceText) + "\n\t\t\t\t"),
          _vm.order.size
            ? _c("span", { staticClass: "omc-spec" }, [
                _vm._v("规格：" + _vm._s(_vm.order.size))
              ])
            : _vm._e()
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "omc-recv" }, [
      _c("div", { staticClass: "omc-row" }, [
        _vm._v(
          "收件人：" + _vm._s(_vm.order.name) + "　" + _vm._s(_vm.order.phone)
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "omc-row" }, [
        _vm._v("地址：" + _vm._s(_vm.order.address))
      ]),
      _vm._v(" "),
      _vm.order.remark
        ? _c("div", { staticClass: "omc-row" }, [
            _vm._v("备注：" + _vm._s(_vm.order.remark))
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2da29697", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da29697","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/FBT/components/OrderMsgCard.vue
// module id = 1717
// module chunks = 0